import { Container, Button, Alert } from '../../components/ui';
import TarjetaNotificacion from './TarjetaNotificacion';
import './Notificaciones.css';

// Datos de ejemplo: maqueta (la integración de notificaciones no es requisito de esta entrega).
const NOTIS = [
  { id: 1, tono: 'info', titulo: 'Turno confirmado', texto: 'Tu turno con la Dra. Laura González el Lun 6 jul · 09:00 fue confirmado.', cuando: 'Hace 2 horas', leida: false },
  { id: 2, tono: 'warning', titulo: 'Solicitud de cambio de fecha', texto: 'El Dr. Pablo Ramírez propuso mover tu turno de Dermatología al Mié 15 jul · 16:00.', cuando: 'Ayer', leida: false },
  { id: 3, tono: 'neutral', titulo: 'Recordatorio de turno', texto: 'Te recordamos tu turno de mañana con la Dra. González a las 09:00.', cuando: 'Hace 3 días', leida: true },
  { id: 4, tono: 'neutral', titulo: 'Turno cancelado', texto: 'Tu turno de Oftalmología del 12 may fue cancelado.', cuando: '12 may', leida: true },
];

export default function Notificaciones() {
  return (
    <Container narrow>
      <div className="notificaciones-head">
        <h1 style={{ margin: 0 }}>Notificaciones</h1>
        <Button variant="secondary" size="sm">Marcar todas como leídas</Button>
      </div>

      <Alert tone="info">Vista de maqueta con datos de ejemplo (la integración de notificaciones no es requisito de la Entrega 3).</Alert>

      <ul className="notificaciones-list">
        {NOTIS.map((n) => (
          <li key={n.id}><TarjetaNotificacion noti={n} /></li>
        ))}
      </ul>
    </Container>
  );
}